import { boolean, InferType, object, string } from "yup";

export type IFormularioPagHiperSchema = InferType<typeof formPagHiperSchema>;

export const formPagHiperSchema = object({
  date: string().required(),
  empresa: string().required(),
  selecionarPeriodo: boolean().required(),
  inicio: string().nullable(),
  fim: string().nullable(),
  tipoDePesquisa: string().required()
});
